import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "../../i18n/LanguageContext";

// Known cancelled_reason codes with a translated label. Unknown/free-text
// values fall back to showing the raw value as-is (see reasonLabel below).
const KNOWN_CANCELLED_REASONS = ["customer"];

// Cancelled tests skip the 7-step row entirely (timeline is null) — a
// distinct red/grey badge instead, visually separate from both the normal
// in-progress row and the green "completed" look.
function CancelledTestBadge({ test }) {
  const { t } = useTranslation();
  const { cancelled_at, cancelled_reason } = test;
  const reasonLabel = cancelled_reason
    ? KNOWN_CANCELLED_REASONS.includes(cancelled_reason)
      ? t(`portal.statusTimeline.cancelledReasons.${cancelled_reason}`)
      : cancelled_reason
    : null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        bgcolor: "#fef2f2",
        border: "1px solid #fecaca",
      }}
    >
      <Box
        sx={{
          px: 1.25,
          py: 0.375,
          borderRadius: "999px",
          bgcolor: "#fee2e2",
          color: "#b91c1c",
          fontSize: "0.75rem",
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {t("portal.statusTimeline.steps.cancelled.label")}
      </Box>
      <Typography sx={{ fontSize: "0.8125rem", color: "#7f1d1d" }}>
        {cancelled_at ? dayjs(cancelled_at).format("MMM D, YYYY") : "—"}
        {reasonLabel ? ` · ${reasonLabel}` : ""}
      </Typography>
    </Box>
  );
}

export default CancelledTestBadge;
